import script from "./login-main.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-main.vue?vue&type=script&lang=ts&setup=true"

import "./login-main.vue?vue&type=style&index=0&id=04020745&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04020745"]])

export default __exports__